





























import { Component, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, namespace } from 'vuex-class'

const statistics = namespace('statistics')

@Component
export default class AppFooter extends Vue {
  @Action private setCurrentTranslation!: any

  private created() {
    this.onRouteChanged()
  }

  @Watch('$route')
  private onRouteChanged() {
    this.setCurrentTranslation()
  }
}
